<template>
  <div class="add-horse-container">
    <button
      :class="resultsBtn ? 'button-1' : 'button-10'"
      @click="toggleModalOnOff"
      :disabled="loading"
    >
      <span v-show="loading" class="loader"></span>
      <span v-if="!loading">+ BB Add</span>
    </button>
    <!-- <p>{{ currentHorseId }}</p>
  <p>{{ currentUserId }}</p> -->
    <teleport to=".breednet-modal" v-if="showModal">
      <Modal @close="toggleModalOnOff" :key="modalKey">
        <span v-if="currentUser">
          <p class="add-bb-heading">Add Horse To Blackbook</p>
          <span v-if="horseExists">
            {{ horseData.horsename }} is already in your blackbook.
            <p><a href="/blackbook/">Click here</a> to view your blackbook</p>
          </span>
          <span v-else>
            <span v-if="horseAdded">
              <div class="add-horse-header">
                <b>{{ addHorseName }}</b> has been added to you blackbook.
              </div>
              <p><a href="/blackbook/">Click here</a> to view your blackbook</p>
            </span>
            <span v-else
              ><div class="add-horse">
                <div class="add-horse-header">
                  Add <b>{{ horseData.horse }}</b>
                </div>
                <div class="add-horse-body">
                  <div
                    v-if="modalError"
                    class="alert alert-danger"
                    role="alert"
                  >
                    {{ modalError }}
                  </div>
                  <textarea
                    placeholder="Add Comment"
                    class="add-horse-comment-text"
                    v-model="newComment"
                  ></textarea>
                </div>
                <div class="add-horse-footer">
                  <button
                    type="button"
                    class="add-horse-btn btn-secondary"
                    @click="toggleModalOnOff"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    class="add-horse-btn add-horse-btn-primary"
                    @click="addHorse()"
                  >
                    Follow Horse
                  </button>
                </div>
              </div></span
            >
          </span>
        </span>
        <span v-if="!currentUser">
          <h1>Login To Blackbook</h1>
          <div v-if="message" class="message">
            {{ message }}
          </div>
          <div class="input-fields">
            <input
              v-model="email"
              type="email"
              placeholder="Email"
              class="input-line full-width"
              name="email"
            />
            <input
              v-model="password"
              type="password"
              placeholder="Password"
              class="input-line full-width"
              name="password"
            />
          </div>
          <!-- 2 column grid layout for inline styling -->
          <div class="row mb-4">
            <!-- Checkbox -->
            <div class="form-check">
              <input
                v-model="rememberMe"
                class="form-check-input"
                type="checkbox"
                id="rememberMe"
              />
              <label class="form-check-label" for="rememberMe">
                Remember me
              </label>
            </div>

            <div class="row">
              <a href="/blackbook/forgot-password">Forgot password?</a>
            </div>
          </div>
        </span>
        <template v-slot:links>
          <span v-if="!currentUser">
            <button
              class="add-horse-btn add-horse-btn-primary add-horse-btn-block"
              @click="handleLogin"
            >
              Login
            </button>
            <div class="mt-3">
              <p>Not a member? <a href="/blackbook/register">Register</a></p>
            </div>
          </span>
        </template>
      </Modal>
    </teleport>
  </div>
</template>

<script>
import store from "../store";
import Modal from "../components/Modal.vue";
import blackbookService from "../../../../breednet-blackbook-frontend/src/services/blackbook.service";

export default {
  name: "AddHorse",
  props: {
    horseId: String,
    resultsLink: Boolean,
  },
  components: {
    Modal,
  },
  data() {
    return {
      loading: false,
      email: "",
      password: "",
      rememberMe: false,
      currentHorseId: this.horseId,
      currentUserId: "",
      showModal: false,
      modalKey: 0,
      message: "",
      horseExists: false,
      horseData: {},
      newComment: "",
      modalError: "",
      horseAdded: false,
      addHorseName: "",
      resultsBtn: this.resultsLink,
    };
  },
  computed: {
    currentUser() {
      return store.state.auth.user;
    },
  },
  methods: {
    loadData() {
      if (this.showModal) {
        if (this.currentUser) {
          this.currentUserId = this.currentUser.id;
          this.loading = true;

          blackbookService
            .userHorseExists(this.currentUserId, this.horseId)
            .then((response) => {
              if (response) {
                this.horseExists = true;
                this.horseData = response;
                this.loading = false;
                this.modalKey += 1;
              }
            })
            .catch((err) => {
              this.loading = false;
              console.log(err);
            });

          if (!this.horseExists) {
            this.loading = true;
            blackbookService
              .horseByAapId(this.horseId)
              .then((response) => {
                if (response) {
                  this.horseData = response;
                  this.loading = false;
                  this.modalKey += 1;
                }
              })
              .catch((err) => {
                this.loading = false;
                console.log(err);
              });
          }
        }
      }
    },

    toggleModalOnOff() {
      this.showModal = !this.showModal;
      this.loadData();
    },
    handleLogin() {
      var user = {
        email: this.email,
        password: this.password,
        rememberMe: this.rememberMe,
      };
      store.dispatch("auth/login", user).then(
        () => {
          this.loadData();
        },
        (error) => {
          this.message =
            error.response.data.errors ||
            error.response.data.title ||
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },
    addHorse() {
      var aapId = this.horseData.aapId;
      if (!aapId) {
        aapId = 0;
      }
      var horseToAdd = {
        UserId: this.currentUser.id,
        Horsename: this.horseData.horse,
        HorseCountry: this.horseData.horsecountry,
        HorseMasterId: this.horseData.id,
        AapHorseId: aapId,
        Comment: this.newComment,
      };
      blackbookService
        .addUserHorse(horseToAdd)
        .then(() => {
          this.addHorseName = this.horseData.horse;
          this.horseAdded = true;
          this.horseData = "";
          this.newComment = "";
          this.modalKey += 1;
          // this.$router.go();
        })
        .catch((err) => {
          this.modalError = err;
        });
    },
  },
  mounted() {},
};
</script>

<style>
/* CSS */

.button-1 {
  background-color: #1a7c9c;
  border-radius: 20px;
  border-style: none;
  box-shadow: rgba(0, 0, 0, 0.2) 0 3px 5px -1px,
    rgba(0, 0, 0, 0.14) 0 6px 10px 0, rgba(0, 0, 0, 0.12) 0 1px 18px 0;
  box-sizing: border-box;
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  font-family: inherit;
  letter-spacing: 0.2px;
  line-height: normal;
  padding: 5px 15px;
  transition: background box-shadow 280ms ease;
}

.button-1:hover {
  background: #5c737a;
  color: #fff;
}

.button-1:active {
  box-shadow: 0 4px 4px 0 rgb(60 64 67 / 30%),
    0 8px 12px 6px rgb(60 64 67 / 15%);
  outline: none;
  border: 2px solid #1a7c9c20;
}
.button-10 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px 10px;
  font-family: "Open Sans", sans-serif;
  border-radius: 6px;
  border: none;
  color: #fff;
  background: #1a7c9c;
  background-origin: border-box;
  box-shadow: 0px 0.5px 1.5px rgba(54, 122, 246, 0.25),
    inset 0px 0.8px 0px -0.25px rgba(255, 255, 255, 0.2);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  font-size: 0.75em;
  font-weight: 600;
}

.button-10:focus {
  box-shadow: inset 0px 0.8px 0px -0.25px rgba(255, 255, 255, 0.2),
    0px 0.5px 1.5px rgba(54, 122, 246, 0.25),
    0px 0px 0px 3.5px rgba(58, 108, 217, 0.5);
  outline: 0;
}
.button-10:hover {
  background: #1a7c9c90;
}

add-horse-btn {
  font-family: "Open Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.loader,
.loader:after {
  border-radius: 50%;
  width: 1em;
  height: 1em;
}
.loader {
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 0.1em solid rgba(255, 255, 255, 0.2);
  border-right: 0.1em solid rgba(255, 255, 255, 0.2);
  border-bottom: 0.1em solid rgba(255, 255, 255, 0.2);
  border-left: 0.1em solid #ffffff;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
